module.exports = __webpack_public_path__ + "img/warn.2b24893e.svg";